import React, { FC } from 'react';

import leftArrow from '@assets/left-arrow.svg';
import useDeviceType from '@hooks/useDeviceType';
import { TRACK_OFFICE_INFO_BUTTON_CLICK } from '@services/stats';

import st from './GoBackButton.module.css';

type GoBackButtonProps = {
  onClick: () => void;
};

const GoBackButton: FC<GoBackButtonProps> = ({ onClick }) => {
  const { phone } = useDeviceType();

  return !phone ? (
    <button
      data-testid="goBackButton"
      type="button"
      onClick={() => {
        onClick();
        TRACK_OFFICE_INFO_BUTTON_CLICK('goBack');
      }}
      className={st.goBack}
    >
      <img className={st.goBackArrow} src={leftArrow} alt="Go back" />
      Назад
    </button>
  ) : null;
};

export default GoBackButton;
